import axios from "axios";
import { __constants } from "../../constants";
import { apiResponse } from "../../utils";
import { getUsersByConceirge } from "../Concierge";
import moment from "moment"
import { queryGenerator } from "./common";
const BASE_URL = process.env.REACT_APP_SERVER_URL;


export const getBabySittersListing = async (param) => {
    try {
        if (param.conceirgeId) {
            const response = await getUsersByConceirge(`limit=${__constants.listingLimit}${queryGenerator(param)}`, "BabySitter", param.conceirgeId)
            return response;
        } else {
        const config = {
            method: 'GET',
            url: BASE_URL + `/v1/admin/user-management/babysitter?limit=${__constants.listingLimit}${queryGenerator(param)}`,
            headers: {
                'Authorization': `Bearer ${localStorage.getItem(__constants.authToken)}`,
            },
        };
        const response = await axios(config);
        return response;
    }
    } catch (err) {
        console.error("Error in getBabySittersListing >> ", err.message);
        return err.response
    }
}

export const getBabySitterProfileController = async (id,  month = moment().format("YYYY-MM")) => {
    try {
        const config = {
            method: 'GET',
            url: `${BASE_URL}/v1/admin/user-management/babysitter/${id}/${month}`,
            headers: {
                'Authorization': `Bearer ${localStorage.getItem(__constants.authToken)}`,
            },
        };
        const response = await axios(config);
    
        if (response.data.status === 200) { /* Handle logic for API response */
        let frAvailableForBabyCare = [],
            frInterestedForBabyCare = [],
            frSpecialityForBabyCare = [],
            frChildRangeExperience = [],
            frIHaveForBabyCare = [],

            availableForBabyCare = [],
            interestedForBabyCare = [],
            specialityForBabyCare = [],
            childRangeExperience = [],
            iHaveForBabyCare = [],
            experience = [], check;

        response.data.data.preUserDetails.basicDetail.forEach((object) => {  /* format basic */
            if (object.type === "interestedForBabyCare") frInterestedForBabyCare = object.data
            else if (object.type === "availableForBabyCare") frAvailableForBabyCare = object.data
            else if (object.type === "specialityForBabyCare") frSpecialityForBabyCare = object.data
            else if (object.type === "childRangeExperience") frChildRangeExperience = object.data
            else if (object.type === "IHaveForBabyCare") frIHaveForBabyCare = object.data
        })

        check = response.data.data.babysitter.length > 0 && response.data.data.babysitter[0].availableForBabyCare.length > 0
        frAvailableForBabyCare.forEach((outElem) => {  /* Available For */
            if (check && response.data.data.babysitter[0].availableForBabyCare[0].some((innerElem) => innerElem.name === outElem.name)) {
                availableForBabyCare.push({
                    _id: outElem._id,
                    isMarked: true,
                    name: outElem.name,
                    image: outElem.file
                })
            } else if (check) {
                availableForBabyCare.push({
                    _id: outElem._id,
                    isMarked: false,
                    name: outElem.name,
                    image: outElem.file
                })
            }
        })

        check = response.data.data.babysitter.length > 0 && response.data.data.babysitter[0].interestedForBabyCare.length > 0
        frInterestedForBabyCare.forEach((outElem) => { /* Interested For */
            if (check && response.data.data.babysitter[0].interestedForBabyCare[0].some((innerElem) => innerElem.name === outElem.name)) {
                interestedForBabyCare.push({
                    _id: outElem._id,
                    isMarked: true,
                    name: outElem.name,
                    image: outElem.file
                })
            } else if (check) {
                interestedForBabyCare.push({
                    _id: outElem._id,
                    isMarked: false,
                    name: outElem.name,
                    image: outElem.file
                })
            }
        })

        check = response.data.data.babysitter.length > 0 && response.data.data.babysitter[0].speciality.length > 0
        frSpecialityForBabyCare.forEach((outElem) => {  /* Available For */
            if (check && response.data.data.babysitter[0].speciality[0].some((innerElem) => innerElem.name === outElem.name)) {
                specialityForBabyCare.push({
                    _id: outElem._id,
                    isMarked: true,
                    name: outElem.name,
                    image: outElem.file
                })
            } else if (check) {
                specialityForBabyCare.push({
                    _id: outElem._id,
                    isMarked: false,
                    name: outElem.name,
                    image: outElem.file
                })
            }
        })

        check = response.data.data.babysitter.length > 0 && response.data.data.babysitter[0].childRangeExperience.length > 0
        frChildRangeExperience.forEach((outElem) => { /* Interested For */
            if (check && response.data.data.babysitter[0].childRangeExperience[0].some((innerElem) => innerElem.name === outElem.name)) {
                childRangeExperience.push({
                    _id: outElem._id,
                    isMarked: true,
                    name: outElem.name,
                    image: outElem.file
                })
            } else if (check) {
                childRangeExperience.push({
                    _id: outElem._id,
                    isMarked: false,
                    name: outElem.name,
                    image: outElem.file
                })
            }
        })

        check = response.data.data.babysitter.length > 0 && response.data.data.babysitter[0].IHaveForBabyCare.length > 0
        frIHaveForBabyCare.forEach((outElem) => {  /* Available For */
            if (check && response.data.data.babysitter[0].IHaveForBabyCare[0].some((innerElem) => innerElem.name === outElem.name)) {
                iHaveForBabyCare.push({
                    _id: outElem._id,
                    isMarked: true,
                    name: outElem.name,
                    image: outElem.file
                })
            } else if (check) {
                iHaveForBabyCare.push({
                    _id: outElem._id,
                    isMarked: false,
                    name: outElem.name,
                    image: outElem.file
                })
            }

        })

        check = response.data.data.babysitter.length > 0
        response.data.data.preUserDetails.experience.forEach((outElem) => { /* Experience */
            if (check && response.data.data.babysitter[0].experience.some((innerElem) => innerElem.from === outElem.from && innerElem.to === outElem.to)) {
                experience.push({
                    _id: outElem._id,
                    isMarked: true,
                    from: outElem.from,
                    to: outElem.to
                })
            } else if (check) {
                experience.push({
                    _id: outElem._id,
                    isMarked: false,
                    from: outElem.from,
                    to: outElem.to
                })
            }
        })
        return apiResponse({ data: { availableForBabyCare, interestedForBabyCare, specialityForBabyCare, childRangeExperience, iHaveForBabyCare, experience, languages: response.data.data.preUserDetails.countryLanguages, userInfo: response.data.data.babysitter.length > 0 ? response.data.data.babysitter[0] : {} } })
    } else {
        return apiResponse({
            error: response.data.errors,
            status: response.data.status
        })
    }
    } catch (err) {
        console.error("Error in getBabySitterProfileController >> ", err.message);
        return err.response
    }
}
